import { render, staticRenderFns } from "./CreatorProfiles.vue?vue&type=template&id=22f4a1a4"
import script from "./CreatorProfiles.js?vue&type=script&lang=js&external"
export * from "./CreatorProfiles.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports